<ng-container [ngSwitch]="!feedItems">
  <app-placeholder-feed
    *ngSwitchCase="true"
    [grouped]="grouped"
    class="placeholder-container"
  >
  </app-placeholder-feed>

  <div
    *ngSwitchDefault
    class="feed"
    #feedContainer
    [waypoints]="waypoints"
    [waypointActionTriggers]="waypointActionTriggers$"
    [ngSwitch]="feedItems.size > 0"
  >
    <ng-container *ngSwitchCase="true" [ngSwitch]="enableVirtualScroll">
      <virtual-scroll
        *ngSwitchCase="true"
        class="feed-list virtual-scroll"
        [ngClass]="{
          'grouped-feed-items labeled-groups': grouped,
          'last-page-fetched': lastPageFetched
        }"
        [items]="buffer"
        [bufferAmount]="virtualScrollBufferAmount"
        fillToBottom
        [fillToBottomActionTriggers$]="fillToBottomActionTriggers$"
        (onResize)="refreshVirtualScroll()"
        (update)="scrollItems = $event"
        (end)="fetchMore($event)"
      >
        <ng-container
          *ngFor="let feedItem of scrollItems; let pos = index"
          [ngSwitch]="grouped"
        >
          <ng-container
            *ngSwitchCase="true"
            [ngSwitch]="!!feedItem.sectionHeader"
          >
            <div *ngSwitchCase="true" class="section-header-wrapper">
              <div class="section-header">
                <h4 class="section-label">
                  {{ feedItem.sectionHeader.label }}
                </h4>

                <span
                  *ngIf="feedItem.sectionHeader.meta"
                  class="section-metadata"
                >
                  {{ feedItem.sectionHeader.meta }}
                </span>
              </div>
            </div>

            <div
              *ngSwitchDefault
              [ngClass]="{ 'last-grouped-item': feedItem.lastGroupedItem }"
              class="section-item"
            >
              <ng-template
                *ngTemplateOutlet="
                  template;
                  context: {
                    feedItem: feedItem.value,
                    position: feedItem.position
                  }
                "
              ></ng-template>
            </div>
          </ng-container>

          <div *ngSwitchDefault class="feed-item" data-e2e-id="feed-item">
            <ng-template
              *ngTemplateOutlet="
                template;
                context: { feedItem: feedItem, position: pos + 1 }
              "
            ></ng-template>
          </div>
        </ng-container>

        <div
          *ngIf="enablePagination && fetching && !lastPageFetched"
          class="loading-spinner-wrapper"
        >
          <app-icon class="loading-spinner" [icon]="loadingSpinnerIcon">
          </app-icon>
        </div>
      </virtual-scroll>

      <ng-container *ngSwitchDefault [ngSwitch]="grouped">
        <ol
          *ngSwitchCase="true"
          class="feed-list grouped-feed-items labeled-groups"
        >
          <li
            *ngFor="let labeledGroup of feedItems | keyValuePair"
            class="labeled-group-item"
            data-e2e-id="feed-item"
          >
            <app-labeled-section
              [header]="labeledGroup.key"
              [metadata]="groupMetadata?.get(labeledGroup.key, '')"
              [items]="labeledGroup.value"
              [trackByFn]="trackByFn"
            >
              <ng-template let-feedItem="labeledSectionItem">
                <ng-template
                  *ngTemplateOutlet="template; context: { feedItem: feedItem }"
                ></ng-template>
              </ng-template>
            </app-labeled-section>
          </li>
        </ol>

        <ol *ngSwitchDefault class="feed-list">
          <li
            *ngFor="
              let feedItem of feedItems;
              let pos = index;
              trackBy: trackByFn
            "
            class="feed-item"
            data-e2e-id="feed-item"
          >
            <ng-template
              *ngTemplateOutlet="
                template;
                context: { feedItem: feedItem, position: pos + 1 }
              "
            ></ng-template>
          </li>
        </ol>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <div
        class="empty-feed"
        [ngClass]="[
          noItemsOptions?.alignment + '-alignment' || 'center-alignment',
          noItemsOptions?.customTheme || ''
        ]"
      >
        <div class="no-items-container">
          <div *ngIf="noItemsIcon" class="no-items-icon-wrapper">
            <app-icon class="no-items-icon" [icon]="noItemsIcon"> </app-icon>

            <app-premium-icon
              *ngIf="showFeatureHighlight"
              class="premium-icon"
              [iconSize]="premiumIconSize"
              (click)="showFeatureHighlightDialog()"
            >
            </app-premium-icon>
          </div>

          <div class="no-items-text">
            <p
              *ngIf="noItemsOptions?.title as title"
              class="no-items-title"
              data-e2e-id="empty-state-title"
            >
              {{ title }}
            </p>

            <ng-container
              *ngIf="noItemsOptions?.description as description"
              [ngSwitch]="!!noItemsOptions?.htmlDescription"
            >
              <p
                *ngSwitchCase="true"
                class="no-items-description html-container"
                data-e2e-id="empty-state-description"
                [innerHTML]="description | safe: 'html'"
              ></p>

              <p
                *ngSwitchDefault
                class="no-items-description"
                data-e2e-id="empty-state-description"
              >
                {{ description }}
              </p>
            </ng-container>
          </div>

          <i2g-router-link
            *ngIf="noItemsOptions?.primaryAction as primaryAction"
            buttonStyle="emphasis"
            type="create-action"
            class="no-items-primary-action"
            alignment="center"
            [label]="primaryAction.label"
            [route]="primaryAction.route"
            [disabled]="primaryAction.disabled"
            [e2eId]="primaryAction.e2eId"
            [trackingObject]="primaryAction.trackingObject"
            [trackingAction]="primaryAction.trackingAction"
            (click)="onNoItemsPrimaryActionClick.emit()"
          >
          </i2g-router-link>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
